import initialState from '../initialstate';
import * as types from '../../actions/actiontypes';
import {HttpStatusCodes} from '../../util/uiconstants';
import Utility from '../../util/utilityfunctions';

/**
 * This reducer function handles all the actions related to the top-level objects.
 * @param {Object} state - A portion of the overall Redux state, specifically the
 *      storeIgua.<%=names.camel%> object, representing the current data.
 * @param {Object} action - Action object containing type and other values
 * @return {*} current state or array of language objects
 */
export default function multipleNotesSelection(state = initialState.rnhMultipleNotes, action) {
	switch (action.type) {
		case types.ADD_RNH_MULTIPLE_ONE_NOTE: {
			let note = {...action.note};
			let list = [];
			list.push(note);
			return list;
		}
		case types.SET_RNH_SELECTED_NOTE_ID_RESET_CONTEXT: {
			let note = {...action.note};
			let list = [];
			list.push(note);
			return list;
		}
		case types.APPEND_RNH_MULTIPLE_NOTE: {
			let appendNotes = [...action.notes];
			let appendList = [...state];
			appendList = [].concat(appendList, appendNotes);
			return appendList;
		}
		case types.UPDATE_RNH_MULTIPLE_NOTES_BULK_CONTEXT: {
			let appendNotes = [...action.notesToAdd];
			let appendList = [...state];
			appendList = [].concat(appendList, appendNotes);
			return appendList;
		}
		case types.SET_RNH_MULTIPLE_NOTE: {
			let singleNote = {...action.note};
			let selectedNotes = [...state];
			let inList = selectedNotes.some((n) => n.id === singleNote.id);
			if (!inList) {
				selectedNotes.push(singleNote);
			} else {
				for (let i = 0; i < selectedNotes.length; i++) {
					if (selectedNotes[i].id === singleNote.id) {
						selectedNotes.splice(i, 1);
						break;
					}
				}
			}
			return selectedNotes;
		}
		case types.SET_RNH_MULTIPLE_NOTES_CONTEXT: {
			let singleNote = {...action.note};
			let selectedNotes = [...state];
			let inList = selectedNotes.some((n) => n.id === singleNote.id);
			if (!inList) {
				selectedNotes.push(singleNote);
			} else {
				for (let i = 0; i < selectedNotes.length; i++) {
					if (selectedNotes[i].id === singleNote.id) {
						selectedNotes.splice(i, 1);
						break;
					}
				}
			}
			return selectedNotes;
		}
		case types.SELECT_RNH_MULTIPLE_ALL_NOTES: {
			let notes = [...action.notes];
			let notesList = [];
			if (action.hasGroups) {
				let cantNotes = notes.length;
				for (let i = 0; i < cantNotes; i++) {
					notesList = [].concat(notesList, notes[i].responses);
				}
			} else {
				notesList = notes;
			}
			return notesList;
		}
		case types.CLEAN_RNH_MULTIPLE_ALL_NOTES: {
			return [];
		}
		case types.UPDATE_RNH_NOTES_BULK: {
			if (action.responseObj.status === HttpStatusCodes.Ok) {
				let newState = _.cloneDeep(state);
				const userId = action.body.toUser;
				const userName = action.userName;
				const userInitials = action.userInitials;
				const priorityTypeId = action.body.priorityTypeId;
				const annotationStatusId = action.sendCommentData
					? Utility.getAnnotationIdFromComment(action.body.annotationStatusId)
					: action.body.annotationStatusId;
				const dueDate = action.body.dueDate;
				const modifiedDate = action.body.modifiedDate;

				// iterate through annotations list. Is the outter loop because annotations count > selected ids count
				_.forEach(newState, (a) => {
					let element;
					// iterate through selected annotations ids
					_.forEach(action.body.ids, (id) => {
						if (action.hasGroups && a.responses) {
							element = _.find(a.responses, (r) => r.id === id);
						} else {
							if (a.id === id) {
								element = a; // element is the annotation who has not responses
							}
						}
						if (element) {
							if (userId && element.assignedToUserName !== userId) {
								element.assignedToUserId = userId;
								element.assignedToUserName = userName;
								element.assignedToUserInitials = userInitials;
							}
							if (priorityTypeId && element.priorityTypeId !== priorityTypeId) {
								element.priorityTypeId = priorityTypeId;
							}
							if (annotationStatusId && element.statusId !== annotationStatusId) {
								element.statusId = annotationStatusId;
							}
							if (dueDate) {
								element.dueDate = dueDate;
							}
							element.modifiedDate = modifiedDate;
						}
					});
				});

				return newState;
			}
			return state;
		}
		case types.REMOVE_MULTISELECT_NOTE: {
			if (!action.payload.id) return state;

			let notes = _.cloneDeep(state);
			let index = notes.findIndex((t) => t.id === action.payload.id);
			notes.splice(index, 1);
			return _.cloneDeep(notes);
		}
		default:
			return state;
	}
}
